/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSegAllocDetail.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/seg-alloc-detail";

export class AutogenModelSegAllocDetail<RowType extends ModelRow> extends Endpoint<RowType, RowSegAllocDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSegAllocDetail extends ModelRow<RowSegAllocDetailFields> {
	constructor(values?: Partial<RowSegAllocDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSegAllocDetailFields {
	alloc_type: string;
	company_id: string;
	effective_date: Date;
	eq_code: string;
	id: string;
	seg_alloc_code: string;
}

